
var imgBaseUrl = "https://yjly.gispai.com/" //图片本地地址
// var testUrlPath = "http://192.168.2.189:8091/"; //测试接口地址 http://124.71.183.136  http://192.168.2.189
var testUrlPath = "https://yjly.gispai.com/api/"; //测试接口地址 http://124.71.183.136  http://192.168.2.189
//  var GbaseUrl = "http://192.168.2.189:8091/";
 var GbaseUrl = "https://yjly.gispai.com/api/";
 
 var baseUrl2 = "https://yjly.gispai.com/";
 
 var canuseUserIDs=[1,2,17,3359,14,7,3460,3574,3437,3783,4175] //控制哪些用户可使用新功能
var myConfig = {
  baseUrl: GbaseUrl,
  imgUrl: GbaseUrl + '/files/GDataStore',
  imgUrl1: GbaseUrl,
  gspServiceUrl: "http://server.gispai.com/MapServerAPI",
  openMapImageUrl: GbaseUrl + "/files/OpenMap/OpenMapImage/",
  GDataJsonFileUrl: GbaseUrl + "GData/", 
  serverPort: "8091",
  testUrl: testUrlPath,
  imgBaseUrl: imgBaseUrl,
  defaultSymbol: "&#xe601;" ,//默认符号
	canuseUserIDs:canuseUserIDs
}
export {myConfig , baseUrl2}
